<app-modal-view
  #modal="modal"
  modalTitle="Fuel Savings Calculator">

  <app-fuel-savings-calculator modal-body></app-fuel-savings-calculator>

</app-modal-view>
